import { render, staticRenderFns } from "./FiltroRegraCampos.vue?vue&type=template&id=28fa69d3&"
import script from "./FiltroRegraCampos.vue?vue&type=script&lang=js&"
export * from "./FiltroRegraCampos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports